import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "raskFilter",
    pure: false
})
export class FilterPipe implements PipeTransform {

    transform(items: any[], regexfilter: string): any {
        if (!items || !regexfilter) {
            return items;
        }

        return items.filter(item => this.searchItem(item, regexfilter));
    }

    searchItem(item: any, regexfilter: string): boolean {
        for (const key in item) {
            if (Object.hasOwn(item, key)) {
                const value = item[key];

                if (typeof value === "string" && new RegExp(regexfilter, "gi").test(value)) {
                    return true;
                }

                if (typeof value === "object" && this.searchItem(value, regexfilter)) {
                    return true;
                }
            }
        }
        return false;
    }

}
